__turbopack_context__.v({
  "className": "S5DaHq_className",
  "variable": "S5DaHq_variable",
});
